import { SegmentGroup } from "@ttc3k/trekker";
import { useTranslation } from "react-i18next";
import { TabProps } from "shared/types";

enum OrganizationProfileTabsEnum {
  BackOffice = "BACK_OFFICE",
  Profile = "PROFILE",
  Media = "MEDIA",
  Staff = "STAFF",
}

interface OrganizationProfileTabsProps {
  currentTab: OrganizationProfileTabsEnum;
  onTabChange: (value: OrganizationProfileTabsEnum) => void;
}

const OrganizationProfileTabs = ({
  currentTab,
  onTabChange,
}: OrganizationProfileTabsProps) => {
  const { t } = useTranslation("directory", { keyPrefix: "ORGANIZATION" });

  const settingsTabsConfig: TabProps[] = Object.values(
    OrganizationProfileTabsEnum,
  ).map((value) => ({ value, title: t(`${value}.TAB_TITLE`) }));
  return (
    <SegmentGroup.Root
      orientation={"horizontal"}
      value={currentTab}
      onValueChange={(v) => onTabChange(v.value as OrganizationProfileTabsEnum)}
    >
      {settingsTabsConfig.map((tab) => (
        <SegmentGroup.Item value={tab.value} key={tab.value}>
          <span>{tab.title}</span>
        </SegmentGroup.Item>
      ))}
    </SegmentGroup.Root>
  );
};

export { OrganizationProfileTabs, OrganizationProfileTabsEnum };
